import script from "./product-details.vue?vue&type=script&setup=true&lang=js"
export * from "./product-details.vue?vue&type=script&setup=true&lang=js"

import "./product-details.vue?vue&type=style&index=0&id=75671356&lang=css"

const __exports__ = script;

export default __exports__